import React from 'react'
import Navbar from '../../Navbar/Navbar'
import "./Warning.css"
import { useLocation } from 'react-router-dom'
import { useSelector } from 'react-redux'
import { useCreateBookingMutation } from '../../../../Redux/Api/AuthApi'

const Warning = () => {
  const {partyBookingDetails,auth_info} = useSelector((state)=>state.Auth)
  const location = useLocation()
  const dataSlot = location.state
  console.log(partyBookingDetails[4])
  const [createBooking,{isLoading}] = useCreateBookingMutation()

  const handleSubmit = async()=>{
    const data = {
  packageId:partyBookingDetails[4]?.partSummary?.partyPackage?._id,
  date:partyBookingDetails[4]?.partSummary?.partyDateTime?.partydate,
  startTime:partyBookingDetails[4]?.partSummary?.partyDateTime?.partytime,
  endTime:partyBookingDetails[4]?.partyDateTime?.partSummary?.partytime,
  customer:{
    parentName:partyBookingDetails[4]?.partDetail?.partSummary?.firstName ? `${partyBookingDetails[4]?.partSummary?.partDetail?.firstName} + ${partyBookingDetails[4]?.partDetail?.lastName}` : auth_info?.name,
    email: auth_info?.email,
    phone: partyBookingDetails[4]?.partSummary?.partDetail?.phone,
    emergencyContact:partyBookingDetails[4]?.partSummary?.partDetail?.phone
  },
  kidsCount:partyBookingDetails[4]?.partSummary?.partDetail?.numberOfGuest,
  kidsAges:"9",
  assignedCoaches:"pascal",
  pricing:partyBookingDetails[4]?.partSummary?.partyPackage?.basePrice,
  payment:{
    method:partyBookingDetails[4]?.partSummary?.selectedPayment,
    status:"pending"// pending | paid | partial
  },
  waiver:partyBookingDetails[4]?.partSummary?.partDetail?.waiver,
    }
   
   try {
    const response  = await createBooking(data)
     const { pesResponse, subData } = response?.data?.data
      //  handle response shape defensively
       if (pesResponse?.redirect_url) {
         // dispatch(finalOrder(JSON.stringify(orderData)));
        // redirect to pesapal url
          window.location.href = pesResponse?.redirect_url;
          return;
        }
      //  fallback
        console.log("Payment response:", response);
        alert("Payment initialization returned no redirect URL.");
   } catch (error) {
      console.log(error);
      alert("Payment error. Check console.");
   }

  }
  return (
    <div className="kiga-portal-package-main">
      <Navbar />
      <div className="kiga-portal-package-head-title">
        <p>Party Booking</p>
      </div>
      <section className='kiga-portal-package-section'>
       <div className='kiga-portal-summary-section-back'>
        <p>By providing your debit card, credit card, or bank account information and opting in to recurring payments, you certify that you have the authority to authorize debits or charges to the payment information identified here and you authorize The Gymnastics Academy to electronically debit or charge the payment information on a recurring basis in the amount due on or after the due date for your payment.</p>
        <p>Your authorization will remain in effect until you notify us that you wish to revoke this authorization and we have a reasonable opportunity to act on your notice. You may opt out of recurring billing by accessing your account online at www.thegymnasticsacademy.co.uk or on your device by using The iClassPro app.  You may print this authorization or store it electronically and keep it for your records.</p>
        <p>By clicking "Confirm", you will be redirected to our secure payment form.</p>
       </div>
       <div className='kiga-portal-warning-btn'>
         <button onClick={handleSubmit}>Confirm</button>
       </div>
      </section>
      </div>
  )
}

export default Warning